// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IFieldValidator } from "./IFieldValidator"


interface AddressComponentValidatorArguments {
  errorMessages?: {[key: string]: string}
  required?: boolean
}


export class AddressComponentValidator implements IFieldValidator {
  private errorMessages: {[key: string]: string}
  private required: boolean

  constructor(opts?: AddressComponentValidatorArguments) {
    const kwargs = opts || {}
    this.errorMessages = kwargs.errorMessages || {
      "invalid": "INVALID"
    }
    this.required = !!opts?.required
  }

  getErrorMessage(code: string): string {
    return this.errorMessages[code] || this.errorMessages["invalid"]
  }

  validate(value: string | null | undefined): string[] {
    const errors: string[] = []
    if (!value && this.required) {
      return [this.getErrorMessage("required")]
    }
    if (!value) { return []}
    if (!value.match(/^[0-9A-Za-zÀ-ÖØ-öø-ÿ]/i)) {
      errors.push(this.getErrorMessage("invalidStart"))
    }
    if (value.length < 2) {
      errors.push(this.getErrorMessage("minLength"))
    }
    if (value.length > 24) {
      errors.push(this.getErrorMessage("maxLength"))
    }
    if (value.toLowerCase() === value) {
      errors.push(this.getErrorMessage("capitalize"))
    }
    if (value.match(/[\s]$/i)) {
      errors.push(this.getErrorMessage("invalidEnd"))
    }
    if (value.match(/[\s+]{2,}/i)) {
      errors.push(this.getErrorMessage("multipleSpaces"))
    }
    if (!value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ\s-\d\w\.]+$/i)) {
      errors.push(this.getErrorMessage("invalidCharacters"))
    }
    return errors
  }
}